// extracted by mini-css-extract-plugin
export default {"addComment":"AddComment_addComment__E3+NO"};